<template>
    <div>
        <el-container class="home-container">
          <!-- Header -->
          <el-header class="glass-header">
            <el-row type="flex" justify="space-between" align="middle" style="height: 100%;">
              <el-col :span="8">
                <!-- <p class="system-name">后台管理系统</p> -->
                <!-- <el-image class="login_image" :src="logo_url" fit="cover"></el-image> -->
              </el-col>

              <!-- 右侧：用户信息 -->
              <el-col :span="16">
                <div class="user-info-container">


                  <!-- 最新公告 -->
                  <div
                    v-if="latestNews"
                    class="news-notice"
                    @click="openLatestNews"
                  >
                    <i class="el-icon-chat-dot-round news-icon"></i>

                    <span class="news-title">
                    {{ $i18n.locale === 'en-US'
                                      ? latestNews.newsTitleEn
                                      : latestNews.newsTitleCn }}
                  </span>
                  </div>


                  <!--  语言切-->
                  <el-dropdown @command="changeLang" class="lang-dropdown">
                    <span class="el-dropdown-link">
                      <i class="fa fa-language fa-lg" style="margin-right: 6px;"></i>
                      {{ $i18n.locale === 'zh-CN' ? '中文' : 'English' }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
                      <el-dropdown-item command="en-US">English</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>


                  <el-avatar class="user-avatar" icon="el-icon-user-solid"></el-avatar>

                  <el-dropdown>
                  <span class="el-dropdown-link">
                      {{ username }} <i class="fa fa-caret-down fa-1x" style="margin-left: 4px;"></i>
                  </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="logout()">
                        {{ $t('logout') }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>




                </div>
              </el-col>
            </el-row>
          </el-header>

            <el-container style="overflow:auto">
                <!-- 菜单 -->
              <el-aside
                :width="isCollapse ? '64px' : '220px'"
                class="menu-aside">
                <div class="collapse-btn" @click="isCollapse = !isCollapse">
                  <i :class="isCollapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left' "></i>
                </div>

<!--                <el-menu
                  router
                  :default-active="activePath"
                  class="menu-panel"
                  :collapse="isCollapse"
                  background-color="#f5f7fa"
                  text-color="#606266"
                  active-text-color="#409EFF"
                  unique-opened  >


                  <el-menu-item index="/dashboard/Index"
                                @click="saveActiveNav('/dashboard/Index')">
                    <i class="el-icon-s-data"></i>
                    <span slot="title">
                      {{ $t('dashboard') }}
                  </span>
                  </el-menu-item>


                  <el-submenu index="order">
                    <template slot="title">
                      <i class="el-icon-s-order"></i>
                      <span>{{ $t('orderQuery') }}</span>
                    </template>
                    <el-menu-item
                      index="/order/listPage"
                      @click="saveActiveNav('/order/listPage')"
                    >
                      <span>正式数据查询</span>
                    </el-menu-item>
                    <el-menu-item
                      index="/order/listUnnPage"
                      @click="saveActiveNav('/order/listUnnPage')"
                    >
                      <span>挡掉数据查询</span>
                    </el-menu-item>
                  </el-submenu>

                </el-menu>-->

                <el-menu
                  router
                  :default-active="activePath"
                  class="menu-panel"
                  :collapse="isCollapse"
                  background-color="#f5f7fa"
                  text-color="#606266"
                  active-text-color="#409EFF"
                  unique-opened
                >
                  <el-menu-item
                    index="/home/dashboard/Index"
                    @click="saveActiveNav('/home/dashboard/Index')">
                    <i class="el-icon-pie-chart"></i>
                    <span slot="title">
                      {{ $t('dashboard') }}
                  </span>
                  </el-menu-item>

                  <template v-for="menu in menuList">

                    <el-submenu
                      v-if="menu.children && menu.children.length > 0"
                      :key="menu.id"
                      :index="String(menu.id)"
                    >
                      <template slot="title">
<!--                        <i :class="menu.icon || 'el-icon-s-data'"></i>-->
                        <i :class="getMenuIcon(menu)"></i>
                        <span>{{ getMenuName(menu) }}</span>
                      </template>

<!--                      <el-menu-item
                        v-for="child in menu.children"
                        :key="child.id"
                        :index="'/home/' + child.path"
                        @click="saveActiveNav('/' + child.path)"
                      >
                        <span>{{ getMenuName(child) }}</span>
                      </el-menu-item>-->
                      <el-menu-item
                        v-for="child in menu.children"
                        :key="child.id"
                        :index="'/home/' + child.path"
                        @click="saveActiveNav('/home/' + child.path)"
                      >
                        <span>{{ getMenuName(child) }}</span>
                      </el-menu-item>
                    </el-submenu>

<!--                    <el-menu-item
                      v-else
                      :key="'single-' + menu.id"
                      :index="'/home/' + menu.path"
                      @click="saveActiveNav('/' + menu.path)"
                    >
                      <i :class="menu.icon || 'el-icon-menu'"></i>
                      <span slot="title">{{ getMenuName(menu) }}</span>
                    </el-menu-item>-->
                    <el-menu-item
                      v-else
                      :key="'single-' + menu.id"
                      :index="'/home/' + menu.path"
                      @click="saveActiveNav('/home/' + menu.path)"
                    >
                      <i :class="menu.icon || 'el-icon-menu'"></i>
                      <span slot="title">{{ getMenuName(menu) }}</span>
                    </el-menu-item>

                  </template>
                </el-menu>



              </el-aside>



                <el-container>
                <el-main>
                    <Breadcrumb />
                    <router-view></router-view>
                </el-main>

                <el-footer></el-footer>
                </el-container>

            </el-container>



        </el-container>
    </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue';

export default ({
    components: { Breadcrumb },
    data() {
        return {
            avatar:require("@/assets/img/at.jpg"),
            logo_url:require("@/assets/img/93e044f8c14d3a9d7d77654addbb6e8b.svg"),
            isCollapse:false,
            activePath:"",
            username: "",
            menuList:[],
            latestNews: null
        }

    },
    created() {
      this.loadLatestNews();
      this.activePath =
        sessionStorage.getItem("activePath") || "";


      // sessionStorage 中获取并动态赋值用户名
      this.initUserInfo();

      const menus = sessionStorage.getItem("menus");

      //console.log("sessionStorage menus=");
      //console.log(menus);

      if(menus){
        this.menuList = JSON.parse(menus);
      }

   /*   console.log("menuList=");
      console.log(this.menuList);

      console.log(
        "menuList JSON=",
        JSON.stringify(this.menuList, null, 2)
      );*/
    },
    methods: {
      // 菜单图标
      getMenuIcon(menu) {
        const iconMap = {
          "2": "el-icon-s-order",            // 交易
          "4": "el-icon-money",              // 结算
          "1": "el-icon-office-building",    // 商户
          "5": "el-icon-document",           // 日志
          "3": "el-icon-refresh",            // 退款
          "6": "el-icon-setting",            // 系统
          "7": "el-icon-user",               // 用户
          "121": "el-icon-data-analysis"     // 报表
        };

        return iconMap[menu.id] || "el-icon-menu";
      },
      /*新闻消息*/
      async loadLatestNews() {
        try {

          const res = await this.$axios.get(
            '/api/news/latest'
          );

          if (
            res.data.code === 0 &&
            res.data.data
          ) {
            this.latestNews = res.data.data;
          }

        } catch (e) {

          console.error(e);

        }

      },
      openLatestNews() {

        this.$router.push({
          path: '/home/mernews/showNewsManage'
        });

      },
      initUserInfo() {
        const userStr = sessionStorage.getItem("user");
        if (userStr) {
          try {
            // 赋值给 data 中的 username
            this.username = userStr || "Admin";
          } catch (error) {
            console.error("解析用户信息失败:", error);
          }
        }
      },
        // 保存链接的激活状态
      saveActiveNav(activePath){

        sessionStorage.setItem(
          "activePath",
          activePath
        );

        this.activePath = activePath;

      },
      changeLang(command) {
        // command 就是你在 el-dropdown-item 中绑定的 'zh' 或 'en'
        this.$i18n.locale = command;

        //将用户选择的语言保存到 localStorage 中，刷新页面不丢失
        localStorage.setItem('lang', command);

        this.$message.success(command === 'zh-CN' ? '语言切换为中文' : 'Language switched to English');
      },
      //
      getMenuName(item){
   /*     return this.$i18n.locale === 'en-US'
          ? item['en-US']
          : item['zh-CN'];*/
        if(!item.names){
          return "";
        }

        return item.names[this.$i18n.locale]
          || item.names["zh-CN"]
          || "";

      },
      // 退出登录
      async logout() {
        try {
          await this.$axios.get('/api/meradmin/logout');
        } catch (error) {
          //console.error("登出请求失败", error);
        } finally {
          sessionStorage.clear();

          this.$router.push("/login");
        }
      }
    },

})
</script>

<style  scoped>
.home-container {
  position: absolute;
  height: 100%;
  top: 0px;
  left: 0px;
  width: 100%;
  background: #f2f3f5;
}
.login_image{
/* width: 50px; */
    height: 26px;
    margin-top: 20px;

}



.el-aside {
  background: #f5f7fa;
  width: auto !important;
  border-right: 1px solid #ebeef5;
}



.menu-panel {
  border-right: none;
  height: 100%;
}

/*.menu-panel .el-menu-item {
  height: 42px;
  line-height: 42px;
  margin: 4px 8px;
  border-radius: 6px;
}*/

/*.menu-panel .el-submenu__title {
  height: 42px;
  line-height: 42px;
}*/

.menu-panel .el-menu-item:hover {
  background: #eaf2ff !important;
}

.menu-panel .el-menu-item.is-active {
  background: #eaf2ff !important;
  color: #409eff !important;
  font-weight: 600;
}

/* 让普通菜单项和包含子菜单的标题容器保持对齐 */
::v-deep .menu-panel .el-menu-item,
::v-deep .menu-panel .el-submenu__title {
  height: 42px;
  line-height: 42px;
  margin: 4px 8px; /* 统一设置左右 8px 的外边距 */
  border-radius: 6px; /* 统一设置圆角 */
}

/* 统一 hover 悬浮时的背景色 */
::v-deep .menu-panel .el-menu-item:hover,
::v-deep .menu-panel .el-submenu__title:hover {
  background: #eaf2ff !important;
}

/*侧边按钮样式*/
.menu-aside{
  position: relative;
  overflow: visible;
}

.collapse-btn{
  position: absolute;

  top: 20px;

  right: -12px;

  width: 24px;
  height: 24px;

  border-radius: 50%;

  background: #fff;

  border: 1px solid #dcdfe6;

  display:flex;
  align-items:center;
  justify-content:center;

  cursor:pointer;

  z-index:999;
}

.el-aside {
  background: #f5f7fa;
  border-right: 1px solid #ebeef5;
  /* 添加过渡动画，让展开折叠变丝滑 */
  transition: width 0.3s ease-in-out;
}

/* 隐藏折叠时超出边界的内容，防止文字溢出造成的卡顿感 */
.el-menu {
  border-right: none;
}
.menu-panel:not(.el-menu--collapse) {
  width: 220px;
}


/* --- 顶部导航栏毛玻璃效果 --- */
.glass-header {
  /* 使用带有透明度的背景色 */
  background: rgba(255, 255, 255, 0.4) !important;

  /* 核心毛玻璃效果 */
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px); /* 兼容 Safari */

  /* 增加一点底边框和阴影，让层次感更强 */
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);

  /* 确保悬浮在下方内容之上 */
  position: relative;
  z-index: 10;
  padding: 0 20px;
}

/* --- 控制右侧用户信息对齐 --- */
.user-info-container {
  display: flex;
  align-items: center;
  justify-content: flex-end; /* 绝对靠右对齐 */
  height: 100%;
}

.user-avatar {
  background-color: #d0e5f8;
  color: #4c6388;
  margin-right: 12px; /* 和文字保持一点间距 */
}

.el-dropdown-link {
  cursor: pointer;
  color: #333; /* 可以根据毛玻璃背景颜色微调文字颜色 */
  font-weight: 500;
  display: flex;
  align-items: center;
}

/* 让右侧的语言切换和右边的头像保持一定的合理间距 */
.lang-dropdown {
  margin-right: 24px;
}

/* 统一微调一下下拉菜单的文字对齐，让图标和文字处于同一水平线 */
.el-dropdown-link {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.news-notice {
  display: flex;
  align-items: center;

  cursor: pointer;

  /* 与语言切换拉开距离 */
  margin-right: 20px;

  /* 给公告区域固定宽度 */
  width: 150px;

  overflow: hidden;
}

.news-icon {
  color: #f56c6c;
  font-size: 18px;
  flex-shrink: 0;
}

.news-title {
  margin-left: 8px;

  /* 剩余空间全部给标题 */
  flex: 1;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  color: #303133;
}
.news-notice:hover {
  color: #409EFF;
}

.news-notice:hover .news-title {
  color: #409EFF;
}



</style>



<style>
.el-menu--popup {
  min-width: 140px !important;
}
</style>




// WEBPACK FOOTER //
// src/view/Home.vue